module.exports = __webpack_public_path__ + "img/joaquin-urien-byn.430bb5bd.jpg";